import { z } from "zod";

/**
 * ReportChecklistSchema
 */

export const ReportChecklistSchema = z.object({
  area: z.number({ required_error: 'Este campo deve ser preenchido!' }),
  servico: z.array(z.number()).nullable().default(null),
});

/**
 * ReportChecklistForm
 */

export type ReportChecklistForm = z.infer<typeof ReportChecklistSchema>;